import style from './TextLink.module.scss';
import { Link } from 'react-router-dom';

const TextLink = ({ link, children }) => {
  return (
      <Link to={link}  className={style.orange_link}>
        {children}
      </Link>
  )
}

export default TextLink;